import React from 'react'
import Divider from 'components/Shared/Divider'

const BaseDivider: React.FC<{ isFormTitleDivider?: boolean }> = ({ isFormTitleDivider }) => {
    return <Divider maxWidth="755px" className={isFormTitleDivider ? 'first-divider' : 'divider'} />
}

export default BaseDivider
